import { TXStackTemplate } from "../../../types/common/templates.types";
import { X_STACK_TEMPLATE1 } from "./template1";
import { X_STACK_TEMPLATE2 } from "./template2";

export const X_STACK_TEMPLATES: TXStackTemplate = {
  ...X_STACK_TEMPLATE1,
  ...X_STACK_TEMPLATE2,
};
